// Quick add on product cards: [data-quick-add] adds the variant through ClCart and opens the drawer.
document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-quick-add]'); if (!b || !window.ClCart) return;
  e.preventDefault(); b.setAttribute('aria-busy', 'true');
  try {
    await window.ClCart.add([{ id: +b.dataset.variant, quantity: 1 }]);
    const t = b.querySelector('.zc-add-t') || b; // phone shows only the icon; the label stays for screen readers
    t.textContent = b.dataset.added; b.classList.add('done');
    setTimeout(() => { t.textContent = b.dataset.label; b.classList.remove('done'); }, 2400);
  } catch (_) { /* the drawer shows the error */ }
  finally { b.removeAttribute('aria-busy'); }
});
